import { render, staticRenderFns } from "./smsTemplates.vue?vue&type=template&id=79dc3494&scoped=true"
import script from "./smsTemplates.vue?vue&type=script&lang=js"
export * from "./smsTemplates.vue?vue&type=script&lang=js"
import style0 from "./smsTemplates.vue?vue&type=style&index=0&id=79dc3494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc3494",
  null
  
)

export default component.exports